import { motion } from "framer-motion";
import { Star } from "lucide-react";

export default function Testimonials({ items }) {
  if (!items?.length) return null;
  return (
    <section id="reviews" className="py-24 sm:py-32 bg-[#E9ECEF] border-y border-[#0B1215]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="font-mono-label text-[#FF5A36] mb-4">· WHAT CLIENTS SAY</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#0B1215] tracking-tighter max-w-2xl">
              Deposits returned. <span className="italic font-light">Landlords</span> happy.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="testimonials-grid">
          {items.slice(0, 4).map((t, i) => (
            <motion.blockquote
              key={t.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-[#F8F9FA] border-2 border-[#0B1215] p-8 flex flex-col gap-6"
              data-testid={`testimonial-${t.id}`}
            >
              <div className="flex items-center gap-1">
                {[...Array(t.rating || 5)].map((_, idx) => (
                  <Star key={idx} size={18} className="fill-[#FF5A36] text-[#FF5A36]" />
                ))}
              </div>
              <p className="font-display text-lg sm:text-xl leading-snug tracking-tight text-[#0B1215] whitespace-pre-line">
                "{t.quote}"
              </p>
              <footer className="flex items-center gap-4 mt-auto pt-4 border-t border-[#0B1215]/10">
                {t.avatar_url && (
                  <img
                    src={t.avatar_url}
                    alt={t.name}
                    className="w-12 h-12 object-cover grayscale"
                  />
                )}
                <div>
                  <div className="font-semibold text-[#0B1215]">{t.name}</div>
                  <div className="font-mono-label text-[#495057]">{t.location}</div>
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
